import * as React from "react"
import type { IconProps } from "../types"

const Cross = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 20, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeWidth={2}
          d="M5 5L19 19M19 5L5 19"
        />
      </svg>
    )
  }
)
Cross.displayName = "Cross"

export default Cross
